/**
 * B-149 (2026-08-26, owner decision): sold-out offers are HIDDEN from the
 * comparison surfaces entirely. Every offer a shopper sees must be buyable
 * right now - an out-of-stock "best deal" reads as a wrong price and burns
 * trust (owner-caught twice: eBay $154.18 crowned on Oral-B, Cashconverters
 * $389.20 crowned on Canon EOS 1500D, both badged Out of stock).
 *
 * Display-only filter, mirroring priceConfirmedFilter/carrierFilter exactly:
 * the server result, page cache, watches, restock detection, and the
 * "Checked N retailers - M have it in stock" counter all still see the full
 * list. SEO JSON-LD (lib/jsonld.ts) and the negotiation gate already
 * exclude out-of-stock independently.
 *
 * `unknown` and `limited` stock stay visible and crown-eligible: most AU
 * retailers publish no stock signal on the product page, and only an
 * explicit out_of_stock is proof the shopper cannot buy.
 */

export function isBuyableOffer(product: {
  stock_status?: string | null;
}): boolean {
  return product?.stock_status !== "out_of_stock";
}

/**
 * Drop out-of-stock offers from a flat product list. Returns the original
 * list unchanged if filtering would leave nothing (defensive: an
 * all-sold-out result must still render rows - with their badges - rather
 * than a blank page).
 */
export function dropOutOfStockOffers<
  T extends { stock_status?: string | null },
>(products: T[]): T[] {
  const kept = products.filter(isBuyableOffer);
  return kept.length > 0 ? kept : products;
}
